import React from 'react';
import { categories } from '../mock';
import { ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

const Products = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      {/* Header */}
      <section className="bg-gradient-to-br from-[#001F3F] to-[#003366] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">One More Ürünler</h1>
          <p className="text-xl text-white/90 max-w-3xl">
            Kaliteli, eşsiz ürün gamımızla tanışın ve hayat kalitenizi artırın.
          </p>
        </div>
      </section>

      {/* All Products */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {categories.map((category) => (
            <div key={category.id} className="mb-20">
              {/* Category Header */}
              <div className="mb-8">
                <h2 className="text-3xl font-bold text-[#001F3F] mb-4">{category.name}</h2>
                <p className="text-lg text-gray-700">{category.description}</p>
              </div>

              {/* Products Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {category.products.map((product) => (
                  <div 
                    key={product.id}
                    className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105"
                  >
                    <div className="aspect-[3/2] overflow-hidden">
                      <img 
                        src={product.image} 
                        alt={product.name}
                        className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-6">
                      <h3 className="text-lg font-semibold text-[#001F3F] mb-2">{product.name}</h3>
                      <p className="text-gray-600 text-sm mb-4">{product.description}</p>
                      <Button 
                        onClick={() => window.open('https://om.run/!adxpokr', '_blank')}
                        className="w-full bg-[#001F3F] hover:bg-[#003366] text-white py-2 rounded-lg transition-all duration-200"
                      >
                        İncele
                      </Button>
                    </div>
                  </div>
                ))}
              </div>

              {/* Category CTA */}
              <div className="mt-8 text-center">
                <Button 
                  onClick={() => window.open('https://om.run/!adxpokr', '_blank')}
                  className="bg-[#001F3F] hover:bg-[#003366] text-white px-10 py-4 text-base font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
                >
                  Tüm {category.name} Ürünlerini Gör
                  <ArrowRight className="ml-2" size={18} />
                </Button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Products;